module.exports = __webpack_public_path__ + "static/media/scroll.778a5925.png";